import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, OCC_USER_ID_CURRENT, Product, UrlModule, UserIdService } from '@spartacus/core';
import { StarRatingModule } from '@spartacus/storefront';
import { ProductAddToWishListModule } from '../product-add-to-wish-list/product-add-to-wish-list.module';
import { map, of } from 'rxjs';
import { CustomMediaModule } from '../../store-front/misc/media/media.module';
import { ProductMediaComponent } from '../product-media/product-media.component';
import { ProductPriceModule } from '../product-price/product-price.module';
import { CustomAddToCartModule } from '../add-to-cart/add-to-cart.module';
import { fixProductName } from '../../../../core/services/simple-tools';
import { ProductReplacementComponent } from '../product-replacement/product-replacement.component';
import { TARGET_TYPE } from '../../../../core/models/link.model';
import { TooltipIconComponent } from "../../../../components/tooltip-icon/tooltip-icon.component";

@Component({
  selector: 'product-card',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    StarRatingModule,
    ProductAddToWishListModule,
    CustomAddToCartModule,
    CustomMediaModule,
    ProductMediaComponent,
    ProductPriceModule,
    ProductReplacementComponent,
    TooltipIconComponent
  ],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
})
export class ProductCardComponent {
  @Input() product!: Product;
  @Input() highlighted = false;
  @Input() targetURL: TARGET_TYPE = TARGET_TYPE.SELF;
  @Input() lazyPrice = false;

  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));
  fixProductName = fixProductName;
  constructor(private userIdService: UserIdService) {}

  productAsObservable() {
    return of(this.product);
  }
}
